import { useLayoutEffect } from 'react';
import { toast } from 'react-toastify';
import routes from '../../../../../Routes/routes';
import { errorMsg } from '../../../../../Apis/functions';
import { CreateWorkShiftFull } from '../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import CommonWorkShiftApp from './CommonWorkShiftApp';
import { STEPS_CREATE_WORK_SHIFT } from '../Model/Models';

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Create-only hook. Builds the create stepper labels and submits the single work
 * shift body (toRegister: name + schedules + userIds + departmentIds) once.
 * Mirrors ShiftAccess AddShiftAccessApp.
 */
export const CreateWorkShiftApp = () => {

    const {
        t,
        DEV, navigate,
        permission,
        emptyFields,
        disabled, dispatch,
        item, validate,
        handleChange,

        schedules, setSchedules,
        selectDeleteSchedules, setSelectDeleteSchedules,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,

        user, setUser,
        selectDeleteUser, setSelectDeleteUser,
        searchElement,
        setSearchElement,
        steps, setSteps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleOnBack,
        modified, setModified
    } = CommonWorkShiftApp();

    useLayoutEffect(() => {
        const stepArray = Object.values(STEPS_CREATE_WORK_SHIFT)
            .filter(step => step?.TRANS && typeof step.INDEX === "number")
            .sort((a, b) => a.INDEX - b.INDEX)
            .map(step => t(step.TRANS));
        setSteps(stepArray);
    }, [t]);

    /**
     * Validates, builds the work shift body and creates it; on success notifies
     * and navigates back to the list.
     */
    const handleAddEdit = () => {
        if (!validate()) return;
        const body = item.toRegister(schedules, user, departments);
        dispatch(CreateWorkShiftFull(body)).then(({ payload: { data: { success, data, code } } }) => {
            if (success && data?.id) {
                toast.success(t('has_been_created_successfully'));
                navigate(routes.workshift.list);
            } else errorMsg(code);
        });
    }

    return {
        t,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        schedules, setSchedules,
        selectDeleteSchedules, setSelectDeleteSchedules,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,
        modified, setModified,
        user, setUser,
        selectDeleteUser, setSelectDeleteUser,
        searchElement,
        setSearchElement,
        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleAddEdit,
        handleOnBack
    }
}
